import { createTheme, Popover, Portal, Switch } from '@mantine/core';

export const mantineTheme = createTheme({
  defaultRadius: 'sm',
  components: {
    Portal: Portal.extend({
      defaultProps: {
        reuseTargetNode: false,
      },
    }),
    Switch: Switch.extend({
      defaultProps: {
        withThumbIndicator: false,
      },
    }),
    Popover: Popover.extend({
      defaultProps: {
        hideDetached: false,
      },
    }),
  },
});
